import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=6ab53ae9&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"
import style0 from "./Popups.vue?vue&type=style&index=0&id=6ab53ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab53ae9",
  null
  
)

export default component.exports